module.exports = __webpack_public_path__ + "img/banner.3fe2b796.png";